import {
  Activity,
  ArrowDownAZ,
  ArrowUpDown,
  Ban,
  Banknote,
  BarChart3,
  Bitcoin,
  Calendar,
  CalendarClock,
  CalendarDays,
  CheckCircle2,
  CircleDot,
  Clock,
  Coins,
  Dice5,
  Hash,
  Crown,
  Disc3,
  DoorOpen,
  Filter,
  Gamepad2,
  Gift,
  Eye,
  Gauge,
  GitBranch,
  Heart,
  Hourglass,
  Landmark,
  Layers,
  LayoutGrid,
  List,
  ListOrdered,
  Lock,
  Mail,
  Pause,
  PlusCircle,
  Radio,
  Search,
  Sparkles,
  Sun,
  Sunrise,
  Swords,
  Ticket,
  Timer,
  ToggleLeft,
  TrendingDown,
  TrendingUp,
  Trophy,
  Unlock,
  User,
  UserCheck,
  Users,
  Zap,
  Clapperboard,
  Cpu,
  Dumbbell,
  Shield,
  Settings,
  ShieldAlert,
  ScrollText,
  SlidersHorizontal,
  Star,
} from "lucide-react";

/** Bond Play — left game rail */
export const BOND_PLAY_GAME_ICONS = {
  "bond-wheel": Disc3,
  "bond-spin": CircleDot,
  "bond-draw": Ticket,
  "bond-coin": Coins,
  "bond-dice": Dice5,
  "bond-numbers": Hash,
};

/** P2P — status grid */
export const P2P_STATUS_ICONS = {
  Active: Zap,
  Pending: Clock,
  Settled: CheckCircle2,
  Voided: Ban,
};

/** P2P — filter tabs */
export const P2P_FILTER_ICONS = {
  All: LayoutGrid,
  Active: Zap,
  Pending: Clock,
  Settled: CheckCircle2,
  Voided: Ban,
  Created: PlusCircle,
  Joined: UserCheck,
  Invited: Mail,
  Following: Heart,
  Favorites: Star,
};

/** P2P — sort list */
export const P2P_SORT_ICONS = {
  kickoff: CalendarClock,
  "stake-high": TrendingUp,
  "stake-low": TrendingDown,
  "open-slots": DoorOpen,
};

/** Bond House — sort list */
export const HOUSE_SORT_ICONS = {
  bettors: Users,
  pool: Coins,
  fixtures: Calendar,
  name: ArrowDownAZ,
};

/** Bond Predictions (Tips) — filter chips */
export const PREDICTION_FILTER_ICONS = {
  all: LayoutGrid,
  free: Gift,
  premium: Crown,
  unlocked: Unlock,
  today: Sun,
  tomorrow: Sunrise,
  week: CalendarDays,
};

/** Bond Predict (markets) — sort / status / type / category */
export const BP_SORT_ICONS = {
  newest: Sparkles,
  volume: BarChart3,
  closing: Timer,
  activity: Activity,
};

export const BP_STATUS_ICONS = {
  "": LayoutGrid,
  OPEN: Radio,
  CLOSED: Lock,
  RESOLVED: Hourglass,
  FINALIZED: CheckCircle2,
  VOID: Ban,
  ON_HOLD: Pause,
};

export const BP_TYPE_ICONS = {
  "": LayoutGrid,
  BINARY: ToggleLeft,
  MULTI_BINARY: List,
  HEAD_TO_HEAD: Swords,
};

export const BP_LEAGUE_ALL_ICON = Trophy;

export const BP_CATEGORY_ICONS = {
  "": LayoutGrid,
  FOOTBALL: Trophy,
  BASKETBALL: Dumbbell,
  AMERICAN_FOOTBALL: Shield,
  CRYPTO: Bitcoin,
  POLITICS: Landmark,
  ENTERTAINMENT: Clapperboard,
  ESPORTS: Gamepad2,
  TECH: Cpu,
};

/** Portfolio desk */
export const BP_PORTFOLIO_TAB_ICONS = {
  holdings: Layers,
  orders: ListOrdered,
};

export const BP_HOLDINGS_FILTER_ICONS = {
  all: LayoutGrid,
  live: Radio,
  settled: CheckCircle2,
};

export const BP_ORDERS_FILTER_ICONS = {
  all: LayoutGrid,
  working: Hourglass,
  done: CheckCircle2,
};

/** Profile — left section nav */
export const PROFILE_SECTION_ICONS = {
  account: User,
  favorites: Star,
  referral: Gift,
  settings: Settings,
};

/** Fixture desk — board lanes */
export const FIXTURE_TAB_ICONS = {
  upcoming: CalendarClock,
  live: Radio,
  needOdds: SlidersHorizontal,
  past: CheckCircle2,
};

/** Operator Console — left section nav */
export const OPERATOR_SECTION_ICONS = {
  pulse: Activity,
  treasury: Coins,
  loan: Banknote,
  partners: Users,
  matching: GitBranch,
  risk: ShieldAlert,
  fixtures: LayoutGrid,
  bettors: UserCheck,
  tickets: Ticket,
  viewers: Eye,
  followers: Heart,
  activity: ScrollText,
};

export const OPERATOR_BRAND_ICON = Gauge;

/** Section label icons (sidebar headings) */
export const SIDEBAR_SECTION_ICONS = {
  search: Search,
  filter: Filter,
  sort: ArrowUpDown,
  league: Trophy,
  status: Activity,
  dates: CalendarDays,
};

export const pickSidebarIcon = (map, key, fallback = LayoutGrid) =>
  map[key] || map[String(key)] || fallback;
